const area = {
  /** @description INDEFINIDO = 0 */
  INDEFINIDO: 0,
  /** @description Financeiro: SOLICITAR REEMBOLSO COM DESPESAS DIVERSOS (TEC/ENC/ENG) */
  DESPESAS_DIVERSOS: 1,

  /** @description Financeiro: SOLICITAR REEMBOLSO COM DESPESAS DE VIAGENS (ADM) */
  DESPESAS_VIAGEM: 2,

  /** @description Financeiro: SOLICITAR REEMBOLSO COM DESPESAS GERAIS (DIFERENTE DE DIVERSOS[TEC/ENC/ENG] E VIAGENS[ADM]) */
  REEMBOLSO_DESPESAS: 3
}
export default area



// WEBPACK FOOTER //
// ./src/shared/utils/areaDespesa.js